import axios from "axios";
import { getToken } from "./auth";
import { BASE_URL } from '@/config/api';

const apiClient = axios.create({
    baseURL: BASE_URL,
    timeout: 10000,
});

apiClient.interceptors.request.use(config => {

    if (config.skipAuth) {
        return config;
    }

    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        router.push({ name: "login" });
    }

    return config;
}, error => Promise.reject(error));

export const get = (url, params = {}, skipAuth = false, config = {}) => {
  return apiClient.get(url, params, {
    skipAuth,
  });
};

export const post = (url, data = {}, skipAuth = false) => {
    return apiClient.post(url, data, {
        skipAuth,
    });
};

export const getFile = (url, params = {}, skipAuth = false) => {
  return apiClient.get(url, {
    params,
    skipAuth,
    responseType: 'blob',
  });
};
